module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-eeb6fec55b50b61d66c6eb9bb8ecf151.webp";